import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Layout, Checkbox, Select, message, Radio } from 'antd'
import { withTheme } from 'styled-components'
import { PlaidLink } from "react-plaid-link"

import { Flex, FlexColumn } from '../../Reusable/Container'
import { Text } from '../../Reusable/Text';
import { Button } from '../../Reusable/Button'
import { ErrorAlert } from '../../Reusable/Alert'
import { LabeledInput } from '../../Reusable/Input'

// Actions
import { addDataToStore, completeSignin, USERDEFAULTS_SAVE_FLAG, BNK_SAVE_DATA, UAM_SAVE_PERMISSIONS, SAVE_DATA } from '../../../Actions/actions'
// Utils
import { apiGET, apiPOST, apiPOSTReq } from '../../../Utils/api'
import { getUserPermissions } from '../../../Utils/userAccess'
import { isTablet, toCurrency, getBPAccountsWithAccess } from '../../../Utils/util'
import environment from '../../../environment'
import Missing from "../../../Images/missing.png"
import ModalClose from "../../../Images/modal-close.png"
import BankConnect from '../../Settings/External Bank Connect/Index';

const { Option } = Select
const { Content } = Layout

const MinimumDepositModal = (props) => {
    const [loading, setLoading] = useState(false)
    const [showDebitAuthFlow, setShowDebitAuthFlow] = useState(false)
    const [relinkToken, setRelinkToken] = useState("")
    const [bankInfoList, setBankInfoList] = useState([])
    const [bankInfo, setBankInfo] = useState({})
    const [initialDepositAmt, setInitialDepositAmt] = useState()
    const [authorizedTransfer, setAuthorizedTransfer] = useState(false)
    const [checkingAccount, setCheckingAccount] = useState()
    const [checkingAccounts, setCheckingAccounts] = useState()
    const [manualRoutingNumber, setManualRoutingNumber] = useState(false)
    const [manualAccountNumber, setManualAccountNumber] = useState(false)
    const [flowStep, setFlowStep] = useState('deposit')
    const [counterParty, setCounterParty] = useState()
    const [later, setLater] = useState(true)
    const [type, setType] = useState("Business")
    const [linkToken, setLinkToken] = useState("")
    const [accountNumberError, setAccountNumberError] = useState(false)
    const [routingNumberError, setRoutingNumberError] = useState(false)
    const [accountNumberErrorMessage, setAccountNumberErrorMessage] = useState("Couldn’t retrieve your details from Plaid, please enter it manually")
    const [routingNumberErrorMessage, setRoutingNumberErrorMessage] = useState("Couldn’t retrieve your details from Plaid, please enter it manually")
    const [edited, setEdited] = useState(false)
    const [accountUnavailable, setAccountUnavailable] = useState(false)

    const { store, theme, aionStore } = props;
    var { Applications } = store;
    var { UserInfo } = aionStore;
    Applications = Applications || [{}];
    UserInfo = UserInfo || [{}];

    useEffect(() => {
        // Update the document title using the browser API
        fetchAccounts()
        fetchData()
        console.log("ApplicationStatus useEffect")
    }, [])


    useEffect(() => {
        console.log("useEffectsetCheckingAccounts", checkingAccount)
        if (checkingAccount) {
            console.log("useEffectsetCheckingAccounts", checkingAccount)
            if (!checkingAccount.routingNumber) {
                setAccountNumberError(true)
                setManualRoutingNumber(true)
            }
            else if(!edited){
                setManualRoutingNumber(false)
            }
            if (!checkingAccount.accountNumber) {
                setRoutingNumberError(true)
                setManualAccountNumber(true)
            }
            else if(!edited){
                setManualAccountNumber(false)
            }
        }
    }, [checkingAccount])

    const fetchData = () => {
        setLoading(true)
        apiGET("/banking/radius/dashboard", null, (err, resp) => {
            try {
                if (err) throw new Error(err)
                props.dispatch(addDataToStore(BNK_SAVE_DATA, resp.data))
                apiGET("/attributes", null, (err, resp) => {
                    try {
                        const data = resp.data
                        if (data.success) {
                            props.dispatch(completeSignin(data))
                            setLoading(false)
                        } else {
                            throw Error("Could not fetch attributes.")
                        }
                    } catch (error) {
                        console.log("/attr ERR", error.stack)
                        setLoading(false)
                    }
                })
            } catch (error) {
                setLoading(false)
                const fd = fetchData
                ErrorAlert({ description: error.message, okText: "Retry", onOk() { fd() } })
            }
        })
    }

    const fetchAccounts = () => {
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getAccounts`, { "BankProvider": environment.bankProvider.crb }, null, (err, resp) => {
            try {
                console.log("/bb/getAccounts", err, resp)
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)
                    var accounts = data.bbaccounts
                    props.dispatch(addDataToStore(BNK_SAVE_DATA, { BBAccounts: accounts }))
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
                // const fd = fetchAccounts
                // ErrorAlert({ description: error.message, okText: "Retry", onOk() { fd() } })
            }
        })
    }

    const fetchBankInfo = () => {
        const headers = {
            businesskey: props.aionStore.BusinessUniqueKey
        }
        setLoading(true)
        apiGET("/bankinfo?includeNumbers=true", headers, (err, resp) => {
            setLoading(false)
            try {
                const data = resp.data || {}

                if (data && data.BankInfo && data.BankInfo.length > 0) {
                    setBankInfoList(data.BankInfo || [])

                    var checkingAccounts = []

                    data.BankInfo.forEach(bankInfo => {
                        bankInfo.Accounts.forEach(account => {
                            if (account.AccountSubType === "checking") {
                                account.bankName = bankInfo.Institution
                                account.bankLogo = bankInfo.InstitutionLogo
                                checkingAccounts.push(account)
                            }
                        })
                    })

                    setCheckingAccounts(checkingAccounts)

                    if (!checkingAccounts || checkingAccounts.length === 0) {
                        ErrorAlert({ description: "You must connect a checking account to continue." })
                    } else if (checkingAccounts.length > 1) {
                        setCheckingAccount(checkingAccounts[0])
                        setFlowStep('selectCheckingAccount')
                    } else {
                        setCheckingAccount(checkingAccounts[0])
                        setFlowStep('auth')
                    }
                }
                
            } catch (error) {
                console.log("fetchBankInfo ERROR: ", error.stack)
            }
        })
    }

    const fetchBanks = (bankInfo) => {
        if (bankInfo.integrationProvider == "Plaid") {
            const headers = {}

            const body = {
                "BusinessId": props.store.businessId,
                "itemId": bankInfo.itemId
            }
            apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getAccountInfo`, headers, body, (err, resp) => {
                try {
                    const data = resp;

                    setBankInfoList(bankInfo)

                    if (data && data.accountsList && data.accountsList.length > 0) {
                        var checkingAccounts = []
                        data.accountsList.forEach(account => {

                            if (account.accountSubType === "checking") {
                                account.bankName = bankInfo.bankProvider
                                account.bankLogo = bankInfo.logoUrl
                                checkingAccounts.push(account)
                            }
                        })

                        console.log("Checking account", checkingAccounts)
                        setCheckingAccounts(checkingAccounts)


                        if (!checkingAccounts || checkingAccounts.length === 0) {
                            ErrorAlert({ description: "You must connect a checking account to continue." })
                        } else if (checkingAccounts.length > 1) {
                            setCheckingAccount(checkingAccounts[0])
                            setFlowStep('selectCheckingAccount')
                        } else {
                            setCheckingAccount(checkingAccounts[0])
                            setFlowStep('auth')
                        }
                        setLoading(false)
                    }
                    else {
                        message.error("Cannot retrieve account information from Plaid")
                        setLoading(false)
                        setManualAccountNumber(true)
                        setManualRoutingNumber(true)
                        setAccountNumberError(true)
                        setRoutingNumberError(true)
                        setFlowStep('auth')
                        // ErrorAlert({ description: "Cannot retrieve account information, please try again" })
                    }

                } catch (error) {
                    setLoading(false)
                    console.log("ERROR", error.stack)
                }
            })
        }


    }

    const createCounterParty = () => {
        if ((manualAccountNumber || manualRoutingNumber) || edited) {
            var error = false
            if (!checkingAccount.accountNumber || isNaN(checkingAccount.accountNumber)) {
                setAccountNumberError(true)
                setAccountNumberErrorMessage("A valid account number is required")
                if (!error) error = true
            } else {
                setAccountNumberError(false)
            }

            if (!checkingAccount.routingNumber || isNaN(checkingAccount.routingNumber) || checkingAccount.routingNumber.length != 9) {
                setRoutingNumberError(true)
                setRoutingNumberErrorMessage("A valid routing number is required")
                if (!error) error = true
            } else {
                setRoutingNumberError(false)
            }

            if (error) return
        }

        setLoading(true)

        var body = {
            counterparty: {
                "type": type,
                "nameOnAccount": `${UserInfo.FirstName} ${UserInfo.LastName}`,
                "email": UserInfo.Email,
                "ach": {
                    "accountNumber": checkingAccount.accountNumber,
                    "routingNumber": checkingAccount.routingNumber,
                    "accountType": "checking",
                },
                "contextIdentifier": `${UserInfo.FirstName} ${UserInfo.LastName}`,
                "initiatedBy": `${UserInfo.FirstName} ${UserInfo.LastName}`,
            },
            "BankProvider": environment.bankProvider.crb,
            "fundingSource": true,
            "ruleType": "Recipient"
        }

        console.log("MinimumDepositModal createCounterparty body", body)

        apiPOSTReq(`${environment.bbBaseUrl}/bb/createCounterparty`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp || {}
                if (data.result) {
                    console.log("MinimumDepositModal createCounterparty data", data)

                    setCounterParty(data.counterpartiesObj)
                    // createACHDeposit(data.counterpartiesObj)
                    addTransfer(data.counterpartiesObj)
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/createCounterparty err", error, resp, body)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    const createACHDeposit = (paymentMethodId, counterParty) => {
        var secCode = ""
        if (counterParty.type === "Business") {
            secCode = "ccd"
        } else if (counterParty.type === "Individual") {
            secCode = "ppd"
        }

        const bpAccounts = getBPAccountsWithAccess("Deposits", { permType: "manage", getActiveAccounts: true })
        var bpAccount = bpAccounts && bpAccounts.length > 0 ? bpAccounts[0] : {}

        var body = {
            achTransferObj: {
                paymentMethodId: paymentMethodId,
                accountId: bpAccount.accountId || "",
                accountNumber: bpAccount.accountNumber || "",
                amount: 50,
                counterpartyName: `${UserInfo.FirstName} ${UserInfo.LastName}`,
                counterpartyId: counterParty.id || "",
                counterpartyType: counterParty.type || "",
                direction: "debit",
                secCode: secCode,
                email: UserInfo.Email,
                sendEmail: true,
                userNote: "Initial deposit",
                description: "Initial deposit",
                contextIdentifier: `Initial deposit`,
                initiatedBy: `${UserInfo.FirstName} ${UserInfo.LastName}`,
                initiatedByUserName: UserInfo.Email,
                status: "pending",
                statusMessage: "Transfer has been queued for processing.",
                transactionType: "Pull",
            },
            ruleType: "ACH",
        }

        console.log("MinimumDepositModal createACHDeposit body", body)

        apiPOSTReq(`${environment.bbBaseUrl}/bb/createACH`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            setLoading(false)
            try {
                if (err) throw Error(err)
                const data = resp || {}
                console.log("MinimumDepositModal createACHDeposit data", data)
                if (data.result) {
                    // Set Initial Deposit flag
                    props.dispatch(addDataToStore(USERDEFAULTS_SAVE_FLAG, { BBInitialDepositMade: true }))
                    getStarted()
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/createACH err", error.stack)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    const getInstitutionDetails = async () => {
        return new Promise((resolve) => {
            const body = { routingNumber: checkingAccount.routingNumber };

            console.log("MinimumDepositModal getInstitutionDetails body checkingAccount", body, checkingAccount)

            apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getInstitutionDetails`, {}, body, (err, resp) => {
                try {
                    const data = resp;
                    if (data.result && data.institution) {
                        console.log("MinimumDepositModal getInstitutionDetails data", data)
                        resolve(data.institution.logo);
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                    }
                } catch (error) {
                    console.log("ERRR getInstitutionDetails", error.stack, resp);
                    // ErrorAlert({ description: error.message });
                    resolve(null); // resolve with null in case of error
                }
            });
        });
    }

    const addTransfer = async (counterParty) => {
        const bpAccounts = getBPAccountsWithAccess("Deposits", { permType: "manage", getActiveAccounts: true })
        var bpAccount = bpAccounts && bpAccounts.length > 0 ? bpAccounts[0] : {}

        var body = {
            recipientId: counterParty.objectId,
            accountId: bpAccount.accountId || "",
            recipientDeliveryMode: "ACH",
            nickName: `${checkingAccount.bankName} (${checkingAccount.accountNumber.substring(checkingAccount.accountNumber.length - 4, checkingAccount.accountNumber.length)})`,
            type: "ACH",
            bankDetail: {
                bankName: checkingAccount.bankName,
                // accountName: accountNumber,
                accountNumber: checkingAccount.accountNumber,
                routingNumber: checkingAccount.routingNumber,
                accountType: "Checking",
                type: "ACH",
            },
        }

        const logo = await getInstitutionDetails()

        body.bankDetail.logoUrl = logo

        console.log("MinimumDepositModal addTransfer body", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/addTransferDelivery`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                // if (err) throw Error(err)
                const data = resp || {}
                if (data.result) {
                    console.log("MinimumDepositModal addTransfer data", data)
                    createACHDeposit(data.paymentMethod.id, counterParty)
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/addTransferDelivery err", error, resp, body)
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    const handleTextChange = (event) => {
        if (!edited) setEdited(true)
        if (event && event.target) {
            const id = event.target.id
            const value = event.target.value
            setCheckingAccount(oldState => ({ ...oldState, [id]: value }))
        }
    }

    const getDebitAuthFlowContent = () => {
        switch (flowStep) {
            case 'deposit':
                return <FlexColumn start style={{ width: "450px" }}>
                    <Text heading>Activate your account</Text>
                    <Text color={theme.colors.systemGray}>Initiate a $50 deposit to get started with your new bank account!</Text>
                    <LabeledInput
                        type='read-only'
                        label='Deposit amount'
                        id="Amt"
                        value='$50.00'
                    />
                    <div style={{ color: theme.colors.caption }}>Select your Bank Account</div>
                    <Flex centerHorizontally between style={{ margin: '8px 0 24px' }}>
                        <BankConnect plusIcon onSuccess={() => setLoading(true)} onComplete={(bankInfo) => fetchBanks(bankInfo)} store={props.store} connectOnly minimumDeposit/>  
                    </Flex>
                    <span><i>Remember, this step is <b>required</b> in order to keep your bank account open.</i></span>

                    {/* {
                        later &&
                        <Flex center><a style={{ alignSelf: "center", marginTop: 12 }} onClick={() => props.onCancel()}>Do this later</a></Flex>
                    } */}
                </FlexColumn>

            case 'selectCheckingAccount':
                var items = []
                checkingAccounts.forEach((account, i) => {
                    items.push(
                        <Option key={account.AccountId} value={i}>
                            <Flex start centerHorizontally>{account.bankLogo ? <img width='18px' height='18px' src={`data:image/jpeg;base64,${account.bankLogo}`} /> : account.bankName}<span style={{ marginLeft: 8 }}>{account.AccountName} • {account.Mask}</span></Flex>
                        </Option>
                    )
                })

                return <FlexColumn start style={{ width: "450px" }}>
                    <Text heading>Select checking account</Text>
                    <Text color={theme.colors.systemGray}>Which checking account would you like to use?</Text>
                    <LabeledInput
                        labelcolor={props.theme.colors.secondary3}
                        label="Checking Account"
                        type="select"
                        key="checkingAccount"
                        id="checkingAccount"
                        placeholder="Select checking account"
                        className="no-left-padding"
                        onChange={value => setCheckingAccount(checkingAccounts[value])}
                        value={checkingAccount && <Flex start centerHorizontally>{checkingAccount.bankLogo ? <img width='18px' height='18px' src={`data:image/jpeg;base64,${checkingAccount.bankLogo}`} /> : checkingAccount.bankName}<span style={{ marginLeft: 8 }}>{checkingAccount.AccountName} • {checkingAccount.Mask}</span></Flex>}
                    >
                        {items}
                    </LabeledInput>
                    <Button permtype="Override" solid onClick={() => setFlowStep('auth')} text='Continue' />
                </FlexColumn>
            case 'auth':
                return <FlexColumn start style={{ width: "450px" }}>
                    <Text heading>Bank transfer authorization</Text>
                    <LabeledInput
                        autoFocus
                        labelcolor={props.theme.colors.secondary3}
                        label={`Depository Institution Name`}
                        key={"institution"}
                        value={checkingAccount ? checkingAccount.bankName : ""}
                        id="institution"
                        onChange={handleTextChange}

                    />
                    <LabeledInput
                        autoFocus
                        labelcolor={props.theme.colors.secondary3}
                        label={`Account number`}
                        id="accountNumber"
                        value={checkingAccount ? checkingAccount.accountNumber : ""}
                        maxLength={17}
                        placeholder="Enter Account Number"
                        disabled={!manualAccountNumber}
                        onChange={handleTextChange}
                        error={accountNumberError}
                        errorMessage={accountNumberErrorMessage}
                    />
                    <LabeledInput
                        labelcolor={props.theme.colors.secondary3}
                        label={`Routing number`}
                        id="routingNumber"
                        value={checkingAccount ? checkingAccount.routingNumber : ""}
                        maxLength={9}
                        placeholder="Enter 9 digit Routing Number"
                        disabled={!manualRoutingNumber}
                        onChange={handleTextChange}
                        error={routingNumberError}
                        errorMessage={routingNumberErrorMessage}
                    />
                    <LabeledInput
                        autoFocus
                        label="Type"
                        labelcolor={theme.colors.secondary3}
                        id="type"
                        key="type"
                        value={type}
                        type="radio"
                        divider={false}
                        onChange={(e) => setType(e.target.value)}
                    >
                        <Radio value="Business">Business</Radio>
                        <Radio value="Individual">Individual</Radio>
                    </LabeledInput>
                    <Text margin='0 0 24px 0'>I (we) agree that this ACH transaction I (we) authorize will comply with all applicable laws.</Text>
                    <Checkbox value={authorizedTransfer} onChange={(e) => setAuthorizedTransfer(e.target.checked)}>Please check this box to acknowledge the above statements and authorize the transfer</Checkbox>
                    <Button loading={loading} disabled={authorizedTransfer !== true} permtype="Override" style={{ alignSelf: 'center', width: '100%', marginTop: 70 }} solid onClick={() => authorizedTransfer && createCounterParty()} text='Continue' />
                </FlexColumn>
            default: return <></>
        }
    }

    const getStarted = () => {
        message.success('Initial deposit successful!')
        props.onCancel()
        // // Show Getting Started
        // FAQModal({
        //     type: "getting-started", theme: theme, onOk() {
        //         props.dispatch(addDataToStore(USERDEFAULTS_SAVE_FLAG, { BBShowGettingStarted: false }))
        //         // window.location.reload()
        //         // window.location.href = '/banking/home'
        //         props.history.push('/banking/home')
        //     }
        // })
    }

    return (
        <>
            {getDebitAuthFlowContent()}
        </>
    )
}

function mapStateToProps(state) {
    return {
        store: state.bankingAppReducer,
        aionStore: state.aionAppReducer,
        userDefaults: state.userDefaultsReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(MinimumDepositModal)))